import { FC, MouseEvent } from 'react';

import { LocalCode } from './CopyLocalCode.styles';

type Props = { children?: string; className?: string };

export const CopyLocalCode: FC<Props> = ({ children, className }) => {
    if (!children) {
        return null;
    }

    const copyToClipboard = (e: MouseEvent<HTMLElement>) => {
        const value = e.currentTarget.textContent;
        navigator.clipboard.writeText(value);
        e.stopPropagation();
    };

    return (
        <LocalCode onClick={copyToClipboard} className={className}>
            {children}
        </LocalCode>
    );
};
